import React, {
  useCallback,
  useState,
  useMemo,
} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import {
  Dropdown,
  Checkbox,
  Text,
  Message,
} from './styles';

const MultiSelectionDropdown = (props) => {
  const {
    placeholder,
    value,
    options,
    onChange,
    height,
    loading,
    error,
  } = props;

  const [open, setOpen] = useState(false);

  const selectedValuesMap = useMemo(() => (
    _.keyBy(value, _.identity)
  ), [value]);

  const isAllSelected = useMemo(() => {
    let allSelected = true;
    _.forEach(options, (item) => {
      if (!selectedValuesMap[item.key]) {
        allSelected = false;
      }
    });
    return allSelected;
  }, [selectedValuesMap, options]);

  const handleFilterDataList = useCallback((optionKey, checked) => {
    if (checked) {
      onChange([...value, optionKey]);
    } else {
      onChange(value.filter((key) => optionKey !== key));
    }
  }, [onChange, value]);

  const handleFilterSelectAll = useCallback((checked) => {
    onChange(checked ? _.map(options, 'key') : []);
  }, [onChange, options]);

  return (
    <Dropdown
      open={open}
      onBlur={() => setOpen(false)}
      onFocus={() => setOpen(true)}
      text={<Text>{placeholder}</Text>}
      closeOnChange={false}
      fluid
      className="selection"
      height={height}
      loading={loading}
      error={error}
    >

      <Dropdown.Menu>
        {error && (
          <Message
            error
            header="Error"
            content="Something went wrong"
          />
        )}

        {!error && (
          <Dropdown.Item>
            <Checkbox
              checked={isAllSelected}
              label="Select all"
              onBlur={() => setOpen(false)}
              onFocus={() => setOpen(true)}
              onChange={(e, { checked }) => handleFilterSelectAll(checked)}
            />
          </Dropdown.Item>
        )}

        {!error && !_.isEmpty(options) && options.map((option) => (
          <Dropdown.Item key={option.key}>
            <Checkbox
              checked={!!selectedValuesMap[option.key]}
              label={option.text}
              onBlur={() => setOpen(false)}
              onFocus={() => setOpen(true)}
              onChange={(e, { checked }) => handleFilterDataList(option.key, checked)}
            />
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

MultiSelectionDropdown.propTypes = {
  placeholder: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string,
    name: PropTypes.string,
    key: PropTypes.string,
  })),
  value: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func.isRequired,
  height: PropTypes.string,
  loading: PropTypes.bool,
  error: PropTypes.bool,
};

MultiSelectionDropdown.defaultProps = {
  options: [],
  value: [],
  height: undefined,
  loading: false,
  error: false,
};

export default MultiSelectionDropdown;
